import React, { useState } from 'react';

export default function FlipCard({ image, title, subtitle, details }) {
  const [isFlipped, setIsFlipped] = useState(false);

  return (
    <div
      className="h-80 w-full cursor-pointer "
      onMouseEnter={() => setIsFlipped(true)}
      onMouseLeave={() => setIsFlipped(false)}
      
    >
      <div
        className="relative w-full h-full transition-transform duration-500 ease-in-out"
        style={{
          transformStyle: 'preserve-3d',
          transform: isFlipped ? 'rotateY(180deg)' : 'rotateY(0deg)',
          transition: 'transform 0.8s ease-in-out',
          willChange: 'transform',
        }}
      >
        {/* Front of card - Image */}
        <div
          className="absolute w-full h-full bg-gradient-to-br from-black to-black rounded-lg shadow-lg overflow-hidden"
          style={{ backfaceVisibility: 'hidden' }}
        >
          <img
            src={image || "/placeholder.svg"}
            alt={title}
            className="w-full h-full object-cover opacity-60"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent flex items-end p-6">
            <h3 className="text-white text-2xl font-bold">{title}</h3>
            {/* <h3 className="text-white text-2xl font-bold mb-4">{subtitle}</h3> */}
          </div>
        </div>

        {/* Back of card - Details */}
        <div
          className="absolute w-full h-full bg-white rounded-lg shadow-lg p-6 flex flex-col justify-center"
          style={{ backfaceVisibility: 'hidden', transform: 'rotateY(180deg)' }}
        >
          {/* <h3 className="text-slate-900 text-2xl font-bold mb-4">{title}</h3> */}

          <div className="space-y-3" >
            {details.map((detail, index) => (
              <div key={index} className="flex justify-start gap-2 text-slate-600 text-sm">
                <span className=" font-bold text-black">{detail.label}:</span>
                <span className='font-bold '>{detail.value}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
